(function($) {
    var $module = $('#postcode-checker-container');

    // Handle verify button click event
    // $module.find('#verify-button').on('click', function(event) {
    //     event.preventDefault(); // Prevent default action
    //     checkPostcode();
    // });

     $module.find('#postcode-input').on('input', function(event) {
        checkPostcode();
    });


    // Handle Enter keypress event
    $module.find('#postcode-input').on('keypress', function(event) {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevent default action
        checkPostcode();
        }
    });

    // Function to check postcode
    function checkPostcode() {
        const assembly_service_wrap = document.querySelector('.assembly-service-wrap');
        var input = $module.find('#postcode-input').val().trim().toUpperCase(); // Get the input value, trim whitespace, and convert to uppercase
        var postcodePrefix = input.match(/^[A-Z]+/); // Extract the letter prefix of the postcode

        if (postcodePrefix && validPostcodes.includes(postcodePrefix[0])) {
            $module.find('#postcode-message').text("Assembly service is available in your area.").css('color', 'green');
            $('#m-1721678534295').show(); // Show the element if the postcode is correct
            assembly_service_wrap.classList.remove('assembly-disabled');
        } else {
            $module.find('#postcode-message').text("Unfortunately, our assembly service providers do not currently service your area. However, our support team can still provide step by step assistance.").css('color', 'red');
            $('#m-1721678534295').hide(); // Hide the element if the postcode is incorrect
            assembly_service_wrap.classList.add('assembly-disabled');
        }
    }

    // Change button text based on screen width
    function updateButtonText() {
        if (window.innerWidth <= 767) {
            $module.find('#verify-button').text('Check');
        } else {
            $module.find('#verify-button').text('Check Availability');
        }
    }

    // Run on initial load
    updateButtonText();

    // Run on window resize
    $(window).resize(updateButtonText);

})(window.GemQuery || jQuery);